import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js'

const POOL_DATA = {
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_g6ydS3DbH',
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '2klcpu2mbsobv548bvdcdoid7r',
}

const userPool = new CognitoUserPool(POOL_DATA)

export function login(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool })
    const authDetails = new AuthenticationDetails({ Username: email, Password: password })

    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        const idToken = session.getIdToken().getJwtToken()
        const payload = session.getIdToken().payload
        const userData = {
          id: payload.sub,
          email: payload.email,
          displayName: payload.email.split('@')[0],
          tenantId: payload['custom:tenant_id'] || 'faribault',
          roles: payload['custom:roles'] || 'viewer',
          plant: payload['custom:plant'] || 'FBO',
        }
        localStorage.setItem('auth_token', idToken)
        localStorage.setItem('auth_user', JSON.stringify(userData))
        resolve({ token: idToken, user: userData })
      },
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => {
        delete userAttributes.email_verified
        delete userAttributes.email
        user.completeNewPasswordChallenge(password, userAttributes, {
          onSuccess: (session) => {
            const idToken = session.getIdToken().getJwtToken()
            const payload = session.getIdToken().payload
            const userData = {
              id: payload.sub,
              email: payload.email,
              displayName: payload.email.split('@')[0],
              tenantId: payload['custom:tenant_id'] || 'faribault',
              roles: payload['custom:roles'] || 'viewer',
              plant: payload['custom:plant'] || 'FBO',
            }
            localStorage.setItem('auth_token', idToken)
            localStorage.setItem('auth_user', JSON.stringify(userData))
            resolve({ token: idToken, user: userData })
          },
          onFailure: (err) => reject(err),
        })
      },
    })
  })
}

export function logout() {
  const user = userPool.getCurrentUser()
  if (user) user.signOut()
  localStorage.removeItem('auth_token')
  localStorage.removeItem('auth_user')
}

export function getToken() {
  return localStorage.getItem('auth_token')
}

export function getStoredUser() {
  const raw = localStorage.getItem('auth_user')
  return raw ? JSON.parse(raw) : null
}

export function isAuthenticated() {
  return !!getToken()
}

export function refreshSession() {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser()
    if (!user) return reject(new Error('No user'))
    user.getSession((err, session) => {
      if (err) return reject(err)
      if (session.isValid()) {
        const token = session.getIdToken().getJwtToken()
        localStorage.setItem('auth_token', token)
        resolve(token)
      } else {
        reject(new Error('Session expired'))
      }
    })
  })
}
